import React, {useEffect, useState} from 'react';
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Link} from "react-router-dom";
import {Button} from "primereact/button";
import {InputSwitch} from "primereact/inputswitch";
import {Dialog} from "primereact/dialog";
import {InputText} from "primereact/inputtext";
import {Dropdown} from "primereact/dropdown";
import {ConfirmPopup} from "primereact/confirmpopup";
import {InputTextarea} from "primereact/inputtextarea";
import {PickList} from "primereact/picklist";
import {Tooltip} from "primereact/tooltip";
import * as management from "../../../actions/management";
import * as auth from "../../../actions/auth";
import connect from "react-redux/lib/connect/connect";


const RoleFunctionGroups = props => {
    const [roleFunctionGroup, setRoleFunctionGroup] = useState([]);
    const [roleLkpFunctions, setRoleLkpFunctions] = useState([]);
    const [rfgcTarget, setRfgcTarget] = useState([]);
    const [rfgcSource, setRfgcSource] = useState([]);
    const [textDetailText, setTextDetailText] = useState('');
    const [textDetailHeader, setTextDetailHeader] = useState('');
    const [rolGroupFuncName, setRolGroupFuncName] = useState('');
    const [rolGroupFuncDetail, setRolGroupFuncDetail] = useState('');

    const [rfgModuleId, setRfgModuleId] = useState(null);
    const [temporaryRfgModuleId, setTemporaryRfgModuleId] = useState(null);
    const [rolGroupFuncId, setRolGroupFuncId] = useState(null);
    const [rolGroupDeleteData, setRolGroupDeleteData] = useState(null);

    const [textDetailPopupVisible, setTextDetailPopupVisible] = useState(false);
    const [rfgUpdateBtnVisible, setRfgUpdateBtnVisible] = useState(false);
    const [rfgAddBtnVisible, setRfgAddBtnVisible] = useState(false);
    const [rfgUpdateDialogVisible, setRfgUpdateDialogVisible] = useState(false);
    const [rfgDeletePopupVisible, setRfgDeletePopupVisible] = useState(false);
    const [selectedRfgDeletingPopupVisible, setSelectedRfgDeletingPopupVisible] = useState(false);

    const roleFunctionGroupApiPath = "/api/role_function_group/";
    const rfgDeletePropsType = "DELETE_RFG";
    const rfgUpdatePropsType = "UPDATE_RFG";
    const rfgAddPropsType = "INSERT_RFG";
    const roleAddRole = !!localStorage.getItem('role_add');
    const roleDeleteRole = !!localStorage.getItem('role_delete');
    const roleUpdateRole = !!localStorage.getItem('role_update');

    useEffect(() => {
        getRoleFunctionGroups();

    }, []);

    useEffect(() => {
        if (rfgUpdateBtnVisible && roleLkpFunctions.length > 0) {
            getTargetRoleFunctions();
        }
    }, [rfgUpdateBtnVisible, roleLkpFunctions]);

    useEffect(() => {
        const props_type = props.management.type;
        const props_management = props.management;
        if (props_type === rfgUpdatePropsType && rfgUpdateDialogVisible) {
            if (props_management.management.result) {
                props.showSuccess(props_management.management.message);
                getRoleFunctionGroups();
                onHideModal();
            } else {
                props.showError(props_management.management.message);
            }
        } else if (props_type === rfgAddPropsType && rfgUpdateDialogVisible) {
            if (props_management.management.result) {
                props.showSuccess(props_management.management.message);
                getRoleFunctionGroups();
                onHideModal();
            } else {
                props.showError(props_management.management.message);
            }
        } else if (props_type === rfgDeletePropsType && rfgDeletePopupVisible) {
            if (props_management.management.result) {
                props.showSuccess(props_management.management.message);
                setRolGroupDeleteData(null);
                setRfgDeletePopupVisible(false);
                getRoleFunctionGroups();
            } else {
                props.showError(props_management.management.message);
            }
        }

    }, [props.management]);

    const onHideModal = () => {
        setRfgcSource([]);
        setRfgcTarget([]);
        setRoleLkpFunctions([]);
        setRolGroupFuncName('');
        setRolGroupFuncDetail('');
        setRfgUpdateBtnVisible(false);
        setRfgAddBtnVisible(false);
        setRfgUpdateDialogVisible(false);
    }

    const getTargetRoleFunctions = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            fetch('/api/role_function_group/' + rolGroupFuncId + '/', {headers,})
                .then(res => {
                    if (res.status < 500) {
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        let data = res.data;

                        if (data.result === 0) {
                            this.showError(data.message)
                        } else {
                            setRfgcTarget([]);
                            setRfgcSource([]);
                            let rlf_list = roleLkpFunctions;
                            let rfgc_list = data;
                            for (let i = 0; i < rlf_list.length; i++) {
                                let contains = false;
                                for (let j = 0; j < rfgc_list.length; j++) {
                                    if (rlf_list[i].rfun_id === rfgc_list[j].rfun_id) {
                                        contains = true;
                                        setRfgcTarget(rfgcTarget => [...rfgcTarget, rlf_list[i]]);
                                        break;
                                    }
                                }
                                if (!contains) {
                                    setRfgcSource(rfgcSource => [...rfgcSource, rlf_list[i]]);
                                }
                            }

                        }

                    } else if (res.status === 401) {
                        props.loadUser();
                        throw res.data;
                        //dispatch({type: "AUTHENTICATION_ERROR", data: res.data});
                    } else if (res.status === 403) {
                        throw res.data;

                    }
                })
        }
    }

    const getRoleFunctionGroups = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            fetch('api/role/role_function_group/list/', {headers,})
                .then(res => {
                    if (res.status < 500) {
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        let data = res.data;
                        if (data.result === 0) {
                            //showError(data.message)
                        } else {
                            setRoleFunctionGroup(data)
                        }

                    } else if (res.status === 401) {
                        props.loadUser();
                        throw res.data;
                    } else if (res.status === 403) {
                        throw res.data;
                    }
                })
        }
    }

    const rgfAddInitialize = () => {
        setRfgcSource([]);
        setRfgcTarget([]);
        setRolGroupFuncName('');
        setRolGroupFuncDetail('');
        setRolGroupFuncId(null);
        setRfgModuleId(null);
        setRfgUpdateBtnVisible(false);
        setRfgAddBtnVisible(true);
        setRfgUpdateDialogVisible(true);
    }

    const rfgDeleteInitialize = (rowData) => {
        let data = {
            rfg_id: rowData.rfg_id,
            md_id: rowData.md_id,
            rfg_name: rowData.rfg_name,
            rfg_flag_delete: !rowData.rfg_flag_delete,
        };
        setRfgDeletePopupVisible(true);
        setRolGroupDeleteData(data);
        //props.deleteMethod(data, roleFunctionGroupApiPath, rfgDeletePropsType);
    }

    const rfgDelete = () => {
        props.deleteMethod(rolGroupDeleteData, roleFunctionGroupApiPath, rfgDeletePropsType);
    }

    const getFunctionGroup = (module_id) => {
        const path = "/api/role/role_function/list/" + module_id + '/';
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            fetch(path, {headers,})
                .then(res => {
                    if (res.status < 500) {
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        const data = res.data;
                        setRoleLkpFunctions(data);
                        if (rfgAddBtnVisible)
                            setRfgcSource(data);
                    } else if (res.status === 401) {
                        props.loadUser();
                        throw res.data;

                    } else if (res.status === 403) {
                        throw res.data;

                    }
                })
        }
    }

    const rgfUpdateInitialize = (rowData) => {
        getFunctionGroup(rowData.md_id);
        setRolGroupFuncName(rowData.rfg_name);
        setRolGroupFuncDetail(rowData.rfg_detail);
        setRolGroupFuncId(rowData.rfg_id);
        setRfgModuleId(rowData.md_id);
        setRfgUpdateBtnVisible(true);
        setRfgAddBtnVisible(false);
        setRfgUpdateDialogVisible(true);
    }

    const rfgActionTemplate = (rowData) => {
        return <div>
            <InputSwitch
                checked={rowData['rfg_flag_delete']}
                onChange={() => rfgDeleteInitialize(rowData)}
                style={{
                    marginRight: '.5em',
                    visibility: roleDeleteRole ? 'visible' : 'hidden',
                    height: roleDeleteRole ? '' : '0em'
                }}
            />
            <Button
                title="Düzenle"
                icon="pi pi-pencil"
                className="p-button-warning p-mb-1"
                style={{
                    maxHeight: '1.5em',
                    maxWidth: '1.7em',
                    visibility: roleUpdateRole ? 'visible' : 'hidden',
                    height: roleUpdateRole ? '' : '0em'
                }}
                onClick={() => rgfUpdateInitialize(rowData)}>
            </Button>

        </div>
    }

    const rfgNameTemplate = (rowData) => {
        const rfg_name = rowData.rfg_name
        const md_id = rowData.md_id
        if (md_id === 4) {
            if (rfg_name === "candidate") {
                return (
                    <div>
                        <span>Veri Kovanı Aday Etiketleyici</span>
                    </div>
                )
            } else if (rfg_name === "admin") {
                return (
                    <div>
                        <span>Veri Kovanı Yönetici</span>
                    </div>
                )
            } else if (rfg_name === "annotator") {
                return (
                    <div>
                        <span>Veri Kovanı Etiketçi</span>
                    </div>
                )
            } else if (rfg_name === "system_admin") {
                return (
                    <div>
                        <span>Veri Kovanı Sistem Yöneticisi</span>
                    </div>
                )
            } else if (rfg_name === "provider") {
                return (
                    <div>
                        <span>Veri Kovanı Veri Seti Sağlayıcısı</span>
                    </div>
                )
            } else {
                return (
                    <div>
                        <span>{rfg_name}</span>
                    </div>
                )
            }
        } else {
            return (
                <div>
                    <span>{rfg_name}</span>
                </div>
            )
        }
    }

    const mdNameTemplate = (rowData) => {
        const md_color = rowData.md.md_color;
        return (
            <div>
                <span style={{fontSize: '10px', background: md_color}} className="p-badge">{rowData.md.md_name}</span>
            </div>
        )
    }

    const rfgDetail = (rowData) => {
        return <div>
            {textSummary(rowData['rfg_detail'], rowData['rfg_name'])}
        </div>
    }

    const textSummary = (str, header) => {
        if (str.length > 100) {
            return <div>
                {str.substring(0, 100)}...
                <Link onClick={() => textDetail(str, header)} to="#"> Devamını Gör </Link>
            </div>
        } else {
            return str
        }
    }

    const textDetail = (fulltext, text_header) => {
        setTextDetailPopupVisible(true);
        setTextDetailText(fulltext);
        setTextDetailHeader(text_header);
    }

    const rfgTemplate = (item) => {
        const md_color = item.md.md_color;
        return (
            <div className="p-grid" style={{border: `1px solid #a2cdf1`, borderRadius: '8px'}}>
                <div className="p-col-1">
                    <Tooltip target=".custom-target-icon"/>
                    <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                       data-pr-tooltip={item.rfun_name} data-pr-position="right" data-pr-at="right+5 top"
                       data-pr-my="left center-2" style={{fontSize: '1.2rem', cursor: 'pointer', color: md_color}}>
                    </i>
                </div>
                <div className="p-col-11">
                    <strong
                        style={{
                            fontSize: '10px',
                            marginLeft: '0.2em',
                            marginRight: '0.2em'
                        }}>{item.rfun_detail}</strong>
                    <span style={{fontSize: '8px', background: md_color}} className="p-badge">{item.md.md_name}</span>
                </div>
            </div>
        )
    }

    const rfgcPickListChange = (event) => {
        setRfgcSource(event.source);
        setRfgcTarget(event.target);
    }

    const rfgModuleIdChange = (e) => {
        const module_id = e.target.value;
        setTemporaryRfgModuleId(module_id);

        if (rfgcTarget.length > 0) {
            setSelectedRfgDeletingPopupVisible(true);
        } else {
            setSelectedRfgDeletingPopupVisible(false);
            setTemporaryRfgModuleId(module_id);
            setRfgModuleId(module_id)
            getFunctionGroup(module_id);
        }
    }

    const rgfUpdate = () => {
        let rfgc_list = [];
        let rfgc_target_list = rfgcTarget;
        for (let i = 0; i < rfgc_target_list.length; i++) {
            rfgc_list.push({
                'rfun_id': rfgc_target_list[i].rfun_id,
                'rfun_name': rfgc_target_list[i].rfun_name
            })
        }
        let data = {
            rfg_name: rolGroupFuncName,
            rfg_detail: rolGroupFuncDetail,
            rfg_id: rolGroupFuncId,
            md_id: rfgModuleId,
            rfg_flag_delete: false,
            rfg_connection: rfgc_list,
        };
        props.putMethod(data, roleFunctionGroupApiPath, rfgUpdatePropsType)
    }

    const rgfAdd = () => {
        let rfgc_list = [];
        let rfgc_target_list = rfgcTarget;
        for (let i = 0; i < rfgc_target_list.length; i++) {
            rfgc_list.push({'rfun_id': rfgc_target_list[i].rfun_id})
        }
        let data = {
            rfg_name: rolGroupFuncName,
            rfg_detail: rolGroupFuncDetail,
            md_id: rfgModuleId,
            rfg_flag_delete: false,
            rfg_connection: rfgc_list,
        };
        props.postMethod(data, roleFunctionGroupApiPath, rfgAddPropsType)

    }

    const rfgAccept = () => {
        setRfgcTarget([]);
        setRfgcSource([]);
        //this.setState({rfg_module_id: this.state.temporary_rfg_module_id});
        getFunctionGroup(temporaryRfgModuleId);
    }

    const rfgReject = () => {
        setSelectedRfgDeletingPopupVisible(false);
        setTemporaryRfgModuleId(null);
    }


    const moduleOptionItems = props.modules.map((data) => (
            {"label": data.md_name, "value": data.md_id}
        )
    );

    const rfg_header = (
        <div style={{'textAlign': 'center'}}>
            Rol Fonksiyon Grupları &nbsp;&nbsp;
            <Button icon="pi pi-plus-circle"
                    title="Rol Fonksiyon Grupları"
                    style={{visibility: roleAddRole ? 'visible' : 'hidden'}}
                    onClick={rgfAddInitialize}
            />
        </div>
    );
    const rfg_update_dialog_footer = (
        <div>
            {
                rfgUpdateBtnVisible ?
                    <Button
                        label="Güncelle"
                        icon="pi pi-check"
                        onClick={rgfUpdate}/>
                    : null}
            {
                rfgAddBtnVisible ?
                    <
                        Button
                        label="Ekle"
                        className="p-button-info"
                        icon="pi pi-check"
                        onClick={rgfAdd}
                    />
                    : null}
            <Button
                label="Vazgeç"
                icon="pi pi-times"
                onClick={() => onHideModal()}
                className="p-button-secondary"/>
        </div>
    );
    const rfg_delete_popup_footer = (
        <div>
            <Button label="Evet"
                    icon="pi pi-check"
                    onClick={rfgDelete}/>
            <Button
                label="Hayır"
                icon="pi pi-times"
                onClick={() => setRfgDeletePopupVisible(false)}
                className="p-button-secondary"/>
        </div>
    );

    return (
        <div>
            <DataTable
                value={roleFunctionGroup}
                header={rfg_header}
                selectionMode="single"
                emptyMessage="Kayıt bulunamadı"
                paginator={true}
                rows={12}
                resizableColumns={true}
                responsive={true}>
                <Column
                    header="İşlevler"
                    body={rfgActionTemplate}
                    style={{
                        width: roleDeleteRole || roleUpdateRole ? '10em' : '0em',
                        visibility: roleUpdateRole || roleDeleteRole ? 'visible' : 'hidden'
                    }}
                />
                <Column
                    style={{fontSize: '13px', textAlign: 'center'}}
                    field="rfg_id"
                    header="No"
                    sortable={true}
                    filter={true}
                />
                <Column
                    field="rfg_name"
                    style={{fontSize: '13px', textAlign: 'center'}}
                    filterMatchMode="contains"
                    header="Grup Adı"
                    sortable={true}
                    filter={true}
                    body={rfgNameTemplate}
                />
                <Column
                    field="md.md_name"
                    style={{fontSize: '13px', textAlign: 'center'}}
                    filterMatchMode="contains"
                    header="Modül"
                    sortable={true}
                    filter={true}
                    body={mdNameTemplate}
                />
                <Column
                    field="rfg_detail"
                    body={rfgDetail}
                    style={{fontSize: '13px', textAlign: 'center'}}
                    filterMatchMode="contains"
                    header="Açıklama"
                    filter={true}/>
            </DataTable>

            <div className="content-section implementation">
                <Dialog header="Rol Fonksiyon Grubu"
                        visible={rfgUpdateDialogVisible}
                        style={{width: '50vw'}}
                        footer={rfg_update_dialog_footer}
                        onHide={() => onHideModal()}
                        dismissableMask={true}
                        maximizable>
                    <div className="p-grid">
                        <div className="p-col-12 p-md-2">
                            <label htmlFor="input">Fonksiyon Adı</label>
                        </div>
                        <div className="p-col-12 p-md-10">
                            <InputText id="rol_group_func_name"
                                       value={rolGroupFuncName}
                                       onChange={event => setRolGroupFuncName(event.target.value)}
                                       size={58}/>
                        </div>
                        <div className="p-col-12 p-md-2">
                            <label htmlFor="input">Modül</label>
                        </div>
                        <div className="p-col-12 p-md-10">
                            <Dropdown options={moduleOptionItems}
                                      inputId="rfg_module_id"
                                      name="rfg_module_id"
                                      value={rfgModuleId}
                                      onChange={e => rfgModuleIdChange(e)}
                                      filter={true}
                                      showClear={true}
                                      required={true}
                                      placeholder="Lütfen Modül Seçiniz"/>
                            <ConfirmPopup
                                target={document.getElementById('rfg_module_id')}
                                visible={selectedRfgDeletingPopupVisible}
                                onHide={() => setSelectedRfgDeletingPopupVisible(false)}
                                message="Seçilen Rol Fonksiyonları Silinecektir"
                                icon="pi pi-exclamation-triangle"
                                acceptLabel="Devam"
                                rejectLabel="Vazgeç"
                                accept={rfgAccept}
                                reject={rfgReject}/>
                        </div>

                        <div className="p-col-12 p-md-2">
                            <label htmlFor="input">Açıklama</label>
                        </div>
                        <div className="p-col-12 p-md-10">
                            <InputTextarea
                                id="rol_group_func_detail"
                                value={rolGroupFuncDetail}
                                onChange={event => setRolGroupFuncDetail(event.target.value)}
                                rows={4}
                                cols={58}>
                            </InputTextarea>
                        </div>
                        <div className="p-col-12 p-md-12">
                            <PickList source={rfgcSource}
                                      target={rfgcTarget}
                                      itemTemplate={rfgTemplate}
                                      sourceHeader="Mevcut"
                                      targetHeader="Seçilenler"
                                      responsive={true}
                                      sourceStyle={{height: '350px'}}
                                      targetStyle={{height: '350px'}}
                                      onChange={rfgcPickListChange}>
                            </PickList>
                        </div>
                    </div>
                </Dialog>
            </div>

            <div className="content-section implementation">
                <Dialog
                    header="Uyarı!"
                    visible={rfgDeletePopupVisible} style={{width: '45vw'}}
                    onHide={() => this.setState(setRfgDeletePopupVisible(false))}
                    footer={rfg_delete_popup_footer}>
                    {rolGroupDeleteData ? rolGroupDeleteData.rfg_flag_delete ? 'Pasif Etmek İstediğinizden Emin Misiniz?' :
                        'Aktif Etmek İstediğinizden Emin Misiniz?' : ''}

                </Dialog>
            </div>
            <div className="content-section implementation">
                <Dialog header={textDetailHeader}
                        visible={textDetailPopupVisible}
                        style={{width: '50vw'}}
                        modal={true}
                        onHide={(e) => setTextDetailPopupVisible(false)}>
                    <p>{textDetailText}</p>
                </Dialog>
            </div>
        </div>
    )

}
const mapStateToProps = state => {
    return {
        user: state.auth.user,
        management: state.management,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        putMethod: (data, url, type) => {
            return dispatch(management.putMethod(data, url, type));
        },
        postMethod: (data, url, type) => {
            return dispatch(management.postMethod(data, url, type));
        },
        deleteMethod: (data, url, type) => {
            return dispatch(management.deleteMethod(data, url, type));
        },
        logout: () => dispatch(auth.logout()),
        loadUser: () => {
            return dispatch(auth.loadUser());
        },

    }
};


export default connect(mapStateToProps, mapDispatchToProps)(RoleFunctionGroups);


// WEBPACK FOOTER //
// ./src/pages/rolemanagement/components/RoleFonctionGroups.jsx